import _ from 'lodash';
import { useCallback } from 'react';

/** API & CONSTANTS */

/** UTILS */
import { SummaryReceiptType } from '../types/types';
import { getItemType } from '../utils/paymentUtils';


export const useSummaryReceiptController = (props: SummaryReceiptType) => {

    const getTreatmentData = useCallback((treatment: any, index: any) => {
        const { type, id } = getItemType(treatment, props.systemConfig.menu, index)

        const itemName: any = treatment?.operativeName || treatment?.itemName || '-'

        const baseTotal = treatment?.total || 0
        const totalDcc = parseFloat(treatment?.totalDcc) || 0
        const totalWithDcc = baseTotal + totalDcc
        const initBalance = (!_.isEmpty(props?.initBalance) ? Number(props?.initBalance[index] || 0) : 0)
        const price: any = totalWithDcc - initBalance

        // Calculate paid amount
        const paid: any = props.listOrderPayment?.paid?.[`${type}_${id}`]?.value || 0

        return { itemName, price, paid }
    }, [props.listOrderPayment?.paid, props?.initBalance])


    return {
        getTreatmentData
    }
}
